// extracted by mini-css-extract-plugin
module.exports = {"btn_cta":"HeaderCTA_btn_cta__z00tM","cta_text":"HeaderCTA_cta_text__1_590"};